import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net-buttons";
import "datatables.net-buttons/js/buttons.html5.js";

const Transaction = ({ list }) => {
  const [Options, setOptions] = useState({});
  const [loading, setLoading] = useState(false);
  const [TableHead, setTableHead] = useState([]);
  const [Table, setTable] = useState([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    var data = JSON.stringify({
      ...Options,
      dbname: "erp_eshiksa",
      Branch_id: localStorage.getItem("Branch_id"),
      tag: "studentFormBuilderTransaction",
    });

    var config = {
      method: "post",
      url: "https://erpapi.eshiksa.net/FormBuilderTransactionReport.php",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        if (response.data.error !== 1) {
          setTableHead(response.data.data.headerArray);
          setTable(response.data.data.rowArray);
          $(document).ready(function () {
            var table = $("#table_id").DataTable();
            table.destroy();
            $("#table_id").DataTable({
              responsive: true,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "csv",
                  text: "Download",
                  title: "Form_Builder_Transaction_Report",
                },
              ],
            });
          });
        } else {
          setTableHead([]);
          setTable([]);
        }
        console.log(response.data);
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    $(document).ready(function () {
      var table = $("#table_id").DataTable();
      table.destroy();
      $("#table_id").DataTable({
        responsive: true,
      });
    });
  }, []);

  return (
    <div>
      <form onSubmit={(e) => handleSubmit(e)}>
        <div className="row">
          <div className="col-xl-4">
            Download for
            <select
              name="formUrlToken"
              onChange={(e) =>
                setOptions({
                  ...Options,
                  [e.target.name]: e.target.value.split(",")[0],
                  form_name: e.target.value.split(",")[1],
                })
              }
              className="form-control"
            >
              <option value="">All Form</option>
              {list.map((item) => {
                return (
                  <option value={[item.formUrlToken, item.formName]}>
                    {item.formName}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="col-xl-4">
            From Date
            <input
              name="from_date"
              type="date"
              max={moment().format("YYYY-MM-DD")}
              className="form-control"
              onChange={(e) =>
                setOptions({ ...Options, [e.target.name]: e.target.value })
              }
            ></input>
          </div>
          <div className="col-xl-4">
            To Date
            <input
              name="to_date"
              onChange={(e) =>
                setOptions({ ...Options, [e.target.name]: e.target.value })
              }
              type="date"
              max={moment().format("YYYY-MM-DD")}
              min={moment().format(Options.from_date)}
              className="form-control"
            ></input>
            <div className="text-end">
              <input type="submit" className="btn my-3 btn-sm btn-form"></input>
            </div>
          </div>
          <div className="col-xl-4"></div>
        </div>
      </form>
      {loading ? (
        <>Loading....</>
      ) : (
        <React.Fragment>
          <div className="table-responsive">
            <table id="table_id" className=" display responsive nowrap">
              <thead>
                <tr>
                  {TableHead.map((item) => (
                    <th>{item}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Table.map((item) => {
                  return (
                    <tr>
                      {item.map((list) => {
                        return <td>{list}</td>;
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default Transaction;
